/* eslint-disable camelcase */
import {AppointmentSlotSellerValueObject} from './AppointmentSlotSellerValueObject.js'
import {CloseDealerScheduleListSellerValueObject} from './CloseDealerScheduleListSellerValueObject.js'
import {CloseDealerScheduleSellerValueObject} from './CloseDealerScheduleSellerValueObject.js'
import {ContactDetailsValueObject} from './ContactDetailsValueObject.js'
import {ContactModelSellerResponseValueObject} from './ContactModelSellerResponseValueObject.js'
import {InstantOfferSellerValueObject} from './InstantOfferSellerValueObject.js'
import {RecommendedPriceSellerValueObject} from './RecommendedPriceSellerValueObject.js'
import {SellerValueObject} from './SellerValueObjectLegacy.js'
import {SubscriptionCommitmentSellerValueObject} from './SubscriptionCommitmentSellerValueObject.js'

export class SellerValueObjectsFactory {
  static appointmentSlotSellerValueObject = ({from, to}) => new AppointmentSlotSellerValueObject({from, to})

  static closeDealerScheduleSellerValueObject = ({dealer, distance, schedule}) =>
    new CloseDealerScheduleSellerValueObject({dealer, distance, schedule})

  static closeDealerScheduleListSellerValueObject = ({closeDealerScheduleList}) =>
    new CloseDealerScheduleListSellerValueObject({closeDealerScheduleList})

  static contactDetailsValueObject = ({adId, date, email, name, message, phone, zipCode}) =>
    new ContactDetailsValueObject({adId, date, email, name, message, phone, zipCode})

  static contactModelSellerResponseValueObject = ({leadId}) => new ContactModelSellerResponseValueObject({leadId})

  /**
   *
   * @method
   * @returns {InstantOfferSellerValueObject} instantOfferSellerValueObject
   */
  static instantOfferSellerValueObject = ({appraisal, title}) =>
    new InstantOfferSellerValueObject({
      appraisal,
      title
    })

  /**
   * @returns {RecommendedPriceSellerValueObject}
   */
  static recommendedPriceSellerValueObject = ({
    manufacturerPrice,
    predictedPrice,
    predictedRatio,
    roundedRecommendPrice
  }) =>
    new RecommendedPriceSellerValueObject({
      manufacturerPrice,
      predictedPrice,
      predictedRatio,
      roundedRecommendPrice
    })

  /**
   * @method
   * @returns {SellerValueObject}
   */
  static sellerValueObject = ({contractId, isDealer, isPrivate, dealer, user}) =>
    new SellerValueObject({contractId, isDealer, isPrivate, dealer, user})

  static subscriptionCommitmentSellerValueObject = ({
    totalMonths,
    monthlyPrice,
    kmIncluded,
    kmIncludedPeriod,
    targetBuyer
  }) =>
    SubscriptionCommitmentSellerValueObject.create({
      totalMonths,
      monthlyPrice,
      kmIncluded,
      kmIncludedPeriod,
      targetBuyer
    })
}
